module.exports = __webpack_public_path__ + "1cac308ffb934c908f39e83eb595dfb2.png";